<template>
    <div class="famous-pedia-item" @click="clickItem">
        <!-- 1.标题部分 -->
        <div class="famous-pedia-item-title clearfix">
            <span class="famous-pit-number">{{itemData.replyNum}}<i class="iconfont icon-man"></i></span>
            <span class="famous-pit-name">{{itemData.name.slice(0, 10)}}</span>
        </div>
        <!-- 2.生日信息部分 -->
        <div class="famous-pedia-item-date">
            <span class="famous-pid-sex" v-bind:class="'famous-pid-sex-'+itemData.sex">{{itemData.sex == 0 ? '乾' : '坤'}}</span>{{itemData.dateStr}}
        </div>
        <!-- 3.八字部分 -->
        <div class="famous-pedia-item-eightword dsp-flex">
            <div class="famous-pie-item" v-for="(wordValue, index) in itemData.eightWordArr" v-bind:key="wordValue + index">
                <span v-bind:class="'wd-' + wordValue[0].propXingEn">{{wordValue[0].text}}</span><br /><span v-bind:class="'wd-' + wordValue[1].propXingEn">{{wordValue[1].text}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FamousPediaItem',
    props: {
        itemData: {
            type: Object,
            default() { return {} }
        },
        itemFunc: {
            type: Function,
            default() { return undefined }
        }
    },
    methods: {
        clickItem() {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc(this.itemData);
            }
        }
    }
}
</script>

<style>

</style>